module.exports = "<side-grid grid-title=\"Settings\" list=\"$ctrl.sections\"></side-grid>\n\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/settings/settings.html
// module id = 1412
// module chunks = 0